import { render, staticRenderFns } from "./Terminliste.vue?vue&type=template&id=5a29aca2&"
import script from "./Terminliste.vue?vue&type=script&lang=js&"
export * from "./Terminliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports